var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"customToggleSwitcher"},[_c('ui-toggle-switcher',{attrs:{"value":true},on:{"onChange":function($event){return _vm.onChangeBlocked(_vm.data)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }